/*
 * The design system this folder needs, as plain values.
 *
 * Every host has its own theme and none of them agree on shape, so the chat
 * asks for the eleven things it actually uses and nothing else. A host writes
 * a short adapter; this file supplies defaults so the component still renders
 * if one is missed.
 *
 * Keeping this list short is the point. Every token added here is another thing
 * two codebases have to keep in step.
 */

export const DEFAULTS = {
  accent: '#0071E3',
  background: '#FFFFFF',
  border: '#D2D2D7',
  danger: '#E30000',
  font: "-apple-system, system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  muted: '#86868B',
  onAccent: '#FFFFFF',
  radius: 16,
  subdued: '#F5F5F7',
  subtext: '#6E6E73',
  text: '#1D1D1F'
};
export const resolve = tokens => ({
  ...DEFAULTS,
  ...(tokens || {})
});
const Tokens = {
  DEFAULTS,
  resolve
};
export default Tokens;